<div [formGroup]="form">
  <div class="card-form-group-container">
    <mat-form-field>
      <input
        matInput
        placeholder="Formato di memorizzazione (FVCF)"
        formControlName="FVCF">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Programma di memorizzazione (FVCP)"
        formControlName="FVCP">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Profondità di colore e metodo di memorizzazione (FVCC)"
        formControlName="FVCC">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Unità di misura (FVCU)"
        formControlName="FVCU">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Misure fotografia virtuale (FVCM)"
        formControlName="FVCM">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Note (FVCN)"
        formControlName="FVCN">
    </mat-form-field>
  </div>
</div>
